<template>
  <ViewTopNav :heading="this.viewType" :subheading="this.assetType" :subsubheading="this.assetType1" />

  <div class="position-absolute p-content z-1">
    <div class="col-12 p-0 z-1 h-100">
      <div class="row g-0 h-100">

        <div class="col-12 col-md-6 col-lg-4 m-auto" v-for="asset in assetTypes" :key="asset.guid">
          <div class="row g-0">
            <div class="col-12 position-relative z-1">

              <!-- Videos -->
              <router-link v-if="viewType === 'videos' && collectionId" :to="{
                name: 'VideoView',
                params: {
                  guid: asset.guid,
                  collectionId: asset.videoLibraryId
                }
              }" class="v-link">
                <img :src="theme.streamCdnUrl + '/' + asset.guid + '/' + asset.thumbnailFileName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- Renders -->
              <router-link v-if="viewType === 'renders' || viewType === 'range'" :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: this.assetType,
                  viewType: this.viewType,
                  order: asset.id
                }
              }" class="r-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType1 + '/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- Panoramas -->
              <router-link v-if="viewType === 'panoramas' || viewType === 'virtual-tour' || viewType === 'balcony-views'"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.assetType,
                    viewType: this.viewType,
                    order: asset.id
                  }
                }" class="p-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType1 + '/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- Floorplans -->
              <router-link v-if="viewType === 'floorplans'" :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: this.assetType,
                  viewType: this.viewType,
                  order: asset.id
                }
              }" class="f-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType1 + '/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

              <!-- PDF -->
              <router-link v-if="viewType === 'pdf'" :to="{
                name: 'AssetViewDetail',
                params: {
                  assetType: this.assetType,
                  viewType: this.viewType,
                  order: asset.id
                }
              }" class="f-link">
                <img
                  :src="theme.cdnUrl + '/assets/' + this.assetType1 + '/' + this.assetType + '/' + this.viewType + '/' + asset.LinkName + '?width=700'"
                  class="img-fluid">
                <div class="render-name">
                  {{ asset.title }}
                </div>
              </router-link>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <ViewBotNav />
  <OffCanvas />
</template>

<script>
import ViewTopNav from '@/components/ViewTopNav.vue';
import ViewBotNav from '@/components/ViewBotNav.vue';
import OffCanvas from "@/components/OffCanvas.vue";
import global from '../global';
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetView",
  props: [
    'assetType1',
    'assetType',
    'viewType',
    'lid',
    'collectionId'
  ],
  components: {
    ViewTopNav,
    ViewBotNav,
    OffCanvas
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/' + this.assetType1 + '/' + this.assetType + '/' + this.viewType + '/'),
      videoStatus: false,
      assetNames: null,
      assetUrls: null
    }
  },
  created() {
    if (this.assetType === 'Riverhome-10103-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'Riverhome-10104-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'Penthouse-11501-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'Penthouse-11502') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.penthouse11502Asset.videos
        this.assetNames = this.theme.penthouse11502Asset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.penthouse11502Asset.floorplans
        this.assetNames = this.theme.penthouse11502Asset.floorplansName
        this.assetUrls = this.theme.penthouse11502Asset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.penthouse11502Asset.panoramas
        this.assetNames = this.theme.penthouse11502Asset.panoramasName
        this.assetUrls = this.theme.penthouse11502Asset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.penthouse11502Asset.balcony
        this.assetNames = this.theme.penthouse11502Asset.balconyName
        this.assetUrls = this.theme.penthouse11502Asset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.penthouse11502Asset.renders
        this.assetNames = this.theme.penthouse11502Asset.rendersName
        this.assetUrls = this.theme.penthouse11502Asset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.penthouse11502Asset.range
        this.assetNames = this.theme.penthouse11502Asset.rangeName
        this.assetUrls = this.theme.penthouse11502Asset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.penthouse11502Asset.pdf
        this.assetNames = this.theme.penthouse11502Asset.pdfName
        this.assetUrls = this.theme.penthouse11502Asset.pdfUrl
      }
    } else if (this.assetType === 'Penthouse-11503-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'Penthouse-11504-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'Penthouse-22501-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'Penthouse-22502-(Sold)') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.SoldAsset.videos
        this.assetNames = this.theme.SoldAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.SoldAsset.floorplans
        this.assetNames = this.theme.SoldAsset.floorplansName
        this.assetUrls = this.theme.SoldAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.SoldAsset.panoramas
        this.assetNames = this.theme.SoldAsset.panoramasName
        this.assetUrls = this.theme.SoldAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.SoldAsset.balcony
        this.assetNames = this.theme.SoldAsset.balconyName
        this.assetUrls = this.theme.SoldAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.SoldAsset.renders
        this.assetNames = this.theme.SoldAsset.rendersName
        this.assetUrls = this.theme.SoldAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.SoldAsset.range
        this.assetNames = this.theme.SoldAsset.rangeName
        this.assetUrls = this.theme.SoldAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.SoldAsset.pdf
        this.assetNames = this.theme.SoldAsset.pdfName
        this.assetUrls = this.theme.SoldAsset.pdfUrl
      }
    } else if (this.assetType === 'River-1-Exterior-Building') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.river1ExterioAsset.videos
        this.assetNames = this.theme.river1ExterioAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.river1ExterioAsset.floorplans
        this.assetNames = this.theme.river1ExterioAsset.floorplansName
        this.assetUrls = this.theme.river1ExterioAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.river1ExterioAsset.panoramas
        this.assetNames = this.theme.river1ExterioAsset.panoramasName
        this.assetUrls = this.theme.river1ExterioAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.river1ExterioAsset.balcony
        this.assetNames = this.theme.river1ExterioAsset.balconyName
        this.assetUrls = this.theme.river1ExterioAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.river1ExterioAsset.renders
        this.assetNames = this.theme.river1ExterioAsset.rendersName
        this.assetUrls = this.theme.river1ExterioAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.river1ExterioAsset.range
        this.assetNames = this.theme.river1ExterioAsset.rangeName
        this.assetUrls = this.theme.river1ExterioAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.river1ExterioAsset.pdf
        this.assetNames = this.theme.river1ExterioAsset.pdfName
        this.assetUrls = this.theme.river1ExterioAsset.pdfUrl
      }
    } else if (this.assetType === 'River-1-Rooftop-Amenities') {
      if (this.viewType === 'videos') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.videos
        this.assetNames = this.theme.rooftopAmenitiesAsset.videosName
      } else if (this.viewType === 'floorplans') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.floorplans
        this.assetNames = this.theme.rooftopAmenitiesAsset.floorplansName
        this.assetUrls = this.theme.rooftopAmenitiesAsset.floorplansUrl
      } else if (this.viewType === 'panoramas' || this.viewType === 'virtual-tour') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.panoramas
        this.assetNames = this.theme.rooftopAmenitiesAsset.panoramasName
        this.assetUrls = this.theme.rooftopAmenitiesAsset.panoramasUrl
      } else if (this.viewType === 'balcony-views') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.balcony
        this.assetNames = this.theme.rooftopAmenitiesAsset.balconyName
        this.assetUrls = this.theme.rooftopAmenitiesAsset.balconyUrl
      } else if (this.viewType === 'renders') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.renders
        this.assetNames = this.theme.rooftopAmenitiesAsset.rendersName
        this.assetUrls = this.theme.rooftopAmenitiesAsset.rendersUrl
      } else if (this.viewType === 'range') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.range
        this.assetNames = this.theme.rooftopAmenitiesAsset.rangeName
        this.assetUrls = this.theme.rooftopAmenitiesAsset.rangeUrl
      } else if (this.viewType === 'pdf') {
        this.assetOrder = this.theme.rooftopAmenitiesAsset.pdf
        this.assetNames = this.theme.rooftopAmenitiesAsset.pdfName
        this.assetUrls = this.theme.rooftopAmenitiesAsset.pdfUrl
      }
    }



    // Video type
    if (this.viewType === 'videos') {
      BunnyNetService.getVideos(this.lid, this.collectionId)
        .then(response => {
          // Remap array (inject asset names)
          console.log(response)
          let j = 0;
          const menuItems = response.data.items.map((item) => {
            if (this.assetNames && this.assetNames.length >= 1) {
              return {
                guid: item.guid,
                videoLibraryId: item.videoLibraryId,
                thumbnailFileName: item.thumbnailFileName,
                ObjectName: item.ObjectName,
                title: this.assetNames[j],
                id: j++
              };
            } else {
              return {
                guid: item.guid,
                videoLibraryId: item.videoLibraryId,
                thumbnailFileName: item.thumbnailFileName,
                ObjectName: item.ObjectName,
                title: unslugify(item.title.split('.').slice(0, -1).join(".")).replace("hyphen", "-"),
                id: j++
              };
            }
          });

          // Custom order array
          if (this.assetOrder && this.assetOrder.length >= 1) {
            this.assetTypes = this.reorder(menuItems, this.assetOrder);
          } else {
            this.assetTypes = menuItems;
          }

          this.videoStatus = true
        })
        .catch(error => {
          console.log(error)
        })
      // Renders, Panoramas, Floorplans type
    } else {
      BunnyNetService.getRenders(this.folderStructure, this.assetType)
        .then(response => {
          let j = 0;
          // Remap array
          console.log(response)
          const menuItems = response.data.map((item) => {
            if (this.assetUrls && this.assetUrls.length >= 1) {
              return {
                Guid: item.Guid,
                ObjectName: unslugify(item.ObjectName),
                LinkName: item.ObjectName,
                Path: item.Path,
                IsDirectory: item.IsDirectory,
                StorageZoneName: item.StorageZoneName,
                title: this.assetNames[j],
                url: this.assetUrls[j],
                id: j++
              };
            } else {
              return {
                Guid: item.Guid,
                ObjectName: unslugify(item.ObjectName),
                LinkName: item.ObjectName,
                Path: item.Path,
                IsDirectory: item.IsDirectory,
                StorageZoneName: item.StorageZoneName,
                title: unslugify(item.ObjectName.split('.').slice(0, -1).join(".")).replace("hyphen", "-"),
                url: [],
                id: j++
              };
            }
          });

          // Custom order array
          if (this.assetOrder && this.assetOrder.length >= 1) {
            this.assetTypes = this.reorder(menuItems, this.assetOrder);
          } else {
            this.assetTypes = menuItems
          }
        })
    }
  },
  methods: {
    reorder: function (data_array, real_order) {
      var i, d = {}, result = [];
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    }
  },
  setup() {
    const { theme } = global

    return {
      theme
    }
  }
}
</script>
